import styled from '@emotion/styled';
import { Stack } from '@mui/material';

import { Badge, theme, Typography } from '@/shared/design-system';

export const FieldIconBox = styled(Stack)(({ theme: t }) => ({
  flexShrink: 0,
  width: '16px',
  height: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2px',
  color: t.colors.icon.secondary,
}));

export const FieldLabelColumn = styled(Stack)({
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
});

export const FieldValueText = styled(Typography)({
  overflowWrap: 'anywhere',
}) as typeof Typography;

export const CandidateCardContainer = styled(Stack)({
  flexDirection: 'column',
  gap: '12px',
  padding: '16px 16px 12px',
  borderRadius: '16px',
  backgroundColor: theme.colors.background.raised,
  minWidth: 0,
});

export const CandidateHeaderRow = styled(Stack)({
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
});

export const CandidateNameText = styled(Typography)({
  flex: 1,
  minWidth: 0,
  overflowWrap: 'anywhere',
}) as typeof Typography;

export const CandidateVerdictList = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
});

export const CandidateVerdictRow = styled(Stack)({
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,

  '& > svg': { flexShrink: 0 },
});

export const CandidateVerdictBadge = styled(Badge)({
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
});

export const NewContactCardContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})<{ isDisabled?: boolean }>(({ isDisabled }) => ({
  alignItems: 'center',
  gap: '8px',
  padding: '16px',
  borderRadius: '16px',
  backgroundColor: theme.colors.background.raised,
  ...(isDisabled && { opacity: 0.5, cursor: 'default' }),
}));

export const LegendRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  flexWrap: 'wrap',
});

export const LegendItem = styled(Stack)({
  alignItems: 'center',
  gap: '6px',
});
